module.exports = __webpack_public_path__ + "static/media/LocationMarkerActive.327855fd.svg";